﻿import {ITemplateModel} from "../../Model/Template/ITemplateModel";
import {JsonFetchJson} from "../../Helper/FetchHelper";
import {ResponseApi} from "../../Model/ResponseApi";
import {OnTemplateDelete} from "../../Delegates/TemplateDelegate";
import {NotificationHelper} from "../../Helper/NotificationHelper";

export class TemplateDeleteController {
    public static Delete = async (model: ITemplateModel) => {
        JsonFetchJson.Delete<ResponseApi<boolean>>(`/template/${model.Primarykey}`).then(x => {
            if (x.Data) 
                OnTemplateDelete.Fire(model);
            else NotificationHelper.Instance.error("Impossible de supprimer le template.");
            
            return x.Data;
        })
    }
}